export const version="0.2.0"
export const build = 225

export const project = {
    "dev":"Narravero DEV",
    "test":"Narravero TEST",
    "prod":"Narravero"
}
